export default "__VITE_ASSET__DNW9HhX8__"